import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { IonModal } from '@ionic/angular/common';
import { AppComponent } from '../app.component';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  isMathExpe: boolean;
  
  public ukCountries = {
      "England": "en-GB-ENG",
      "Scotland": "en-GB-SCT",
      "Wales": "en-GB-WLS",
      "Northern Ireland": "en-GB-NIR"
    };
    public ukClassroomLevelsArray;
    public ukClassroomLevels = {
      GS: {
        "en-GB-ENG": "Reception",
        "en-GB-SCT": "P1",
        "en-GB-WLS": "Reception",
        "en-GB-NIR": "Year 1",
      },
      CP: {
        "en-GB-ENG": "Year 1",
        "en-GB-SCT": "P2",
        "en-GB-WLS": "Year 1",
        "en-GB-NIR": "Year 2",
      },
      CE1: {
        "en-GB-ENG": "Year 2",
        "en-GB-SCT": "P3",
        "en-GB-WLS": "Year 2",
        "en-GB-NIR": "Year 3",
      },
      CE2: {
        "en-GB-ENG": "Year 3",
        "en-GB-SCT": "P4",
        "en-GB-WLS": "Year 3",
        "en-GB-NIR": "Year 4",
      },
      CM1: {
        "en-GB-ENG": "Year 4",
        "en-GB-SCT": "P5",
        "en-GB-WLS": "Year 4",
        "en-GB-NIR": "Year 5",
      },
      CM2: {
        "en-GB-ENG": "Year 5",
        "en-GB-SCT": "P6",
        "en-GB-WLS": "Year 5",
        "en-GB-NIR": "Year 6",
      },
      "6eme": {
        "en-GB-ENG": "Year 6",
        "en-GB-SCT": "P7",
        "en-GB-WLS": "Year 6",
        "en-GB-NIR": "Year 7",
      },
    };

  appComponent: AppComponent;
  get loadingModal(): IonModal{
    return this.appComponent.loadingModal;
  }
  set customLoadingMessage(value: any){
    this.appComponent.customMessage = value;
  }
  constructor(public loadingController: LoadingController) { 
    (window as any).gs = this;
    this.isMathExpe = window.document.URL.startsWith("https://dashboard.mathexpedition.com");
    window.document.title = environment.ose === true ? "Kidaia" : (environment.ose === false ? "Mathia" : "");
    this.ukClassroomLevelsArray = Object.entries(this.ukClassroomLevels);

  }

  showLoading(status : boolean, customMessage?:string) {
    if (this.loadingModal){
      this.loadingModal.isOpen = status;
    }
    if(status){
      this.customLoadingMessage = customMessage;
    } else {
      this.customLoadingMessage = "";
    }
  }
}
